import { useCallback, useEffect, useState } from 'react';
import { speak, stopSpeech, subscribeSpeech } from '@/utils/tts';

// Subscribe to the shared speech player; `id` lets a button know if *its* text is speaking.
export function useSpeech() {
  const [state, setState] = useState({ id: null, phase: 'idle' });
  useEffect(() => subscribeSpeech(setState), []);
  const toggle = useCallback((text, id, options) => {
    if (state.id === id && state.phase !== 'idle') { stopSpeech(); return Promise.resolve(); }
    return speak(text, { id, ...options });
  }, [state.id, state.phase]);
  return {
    speakingId: state.phase === 'playing' ? state.id : null,
    loadingId: state.phase === 'loading' ? state.id : null,
    isActive: (id) => state.id === id && state.phase !== 'idle',
    speak,
    stop: stopSpeech,
    toggle,
  };
}
